// Fecha estimada de pago del sueldo líquido en la proyección de FlujoCajaV2: el último día del mes
// menos DIAS_MARGEN_PAGO días hábiles, y nunca en fin de semana (si cayera sáb/dom → día hábil
// anterior). Aplica Chile y Perú. El override manual (pago_sueldo_fecha) SIEMPRE gana sobre esto.
// Ver FASE Prod-1a (reemplaza el default ultimoDiaMes del flujo).

export const DIAS_MARGEN_PAGO = 1;

const esDiaHabil = (d) => {
  const g = d.getDay();
  return g !== 0 && g !== 6; // 0 = domingo, 6 = sábado
};

/**
 * @param {number} año
 * @param {number} mes  1-based (1 = enero … 12 = diciembre)
 * @param {number} [diasMargen=DIAS_MARGEN_PAGO]
 * @returns {string} "YYYY-MM-DD"
 */
export const fechaPagoEstimada = (año, mes, diasMargen = DIAS_MARGEN_PAGO) => {
  const d = new Date(año, mes, 0); // día 0 del mes siguiente = último día del mes `mes`
  let restados = 0;
  while (restados < diasMargen) {
    d.setDate(d.getDate() - 1);
    if (esDiaHabil(d)) restados += 1;
  }
  // Salvaguarda (margen 0, o si por algún borde quedó en fin de semana): correr al día hábil anterior.
  while (!esDiaHabil(d)) d.setDate(d.getDate() - 1);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};
